import React from 'react';
import { FooterRow } from './FooterRow';
export function Footer({ footerData, columns }) {
    if (!footerData) {
        return null;
    }
    return (React.createElement("tfoot", null, footerData.map((footerRow) => (React.createElement(FooterRow, { footerRow: footerRow, columns: columns })))));
}
